import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const GET_KEYSTROKE_DATA = `${API_URL}/api/v1/parent/activity`;
export const DELETE_KEYSTROKE = `${API_URL}/api/v1/parent/delete-activity`;

export function getKeyStrokeData(payload) {
  return axiosInstance({
    url: GET_KEYSTROKE_DATA,
    method: "GET",
    params: payload,
  });
}

export function deleteKeyStroke(payload) {
  return axiosInstance({
    url: DELETE_KEYSTROKE,
    method: "POST",
    data: payload,
  });
}
